import React from 'react';
import { createRoot } from 'react-dom/client';

// Design tokens MUST load before global styles so the custom properties exist.
import './theme/tokens.css';
import './styles/global.css';
import './styles/components.css';
import './styles/detail.css';
import './styles/animations.css';

import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
